import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makeDeleteGuarantorConfig = () => ({
  endpoint: 'users',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'guarantors',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

const requestOptions = makeDeleteGuarantorConfig();

export const consts = createReqConsts('remove-guarantor');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/requests/remove-guarantor-req.js